import React, { useEffect, useState } from 'react'
import { fetchUserLevelsPage } from '../../../../contenful/ContentfulActions';
import { useHistory } from 'react-router';
import { getContainer } from '../../../../ioc/IOCSetup';
import { AppState } from '../../../../RootReducer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserLevelView } from '../../../../user/UserActions';
import { ProgressBar } from 'react-bootstrap';
import { t } from '../../../../i18n';
import { SideMenuComponentsProps } from '../SideMenuComponents';

export default function UserLevelComponent(props: SideMenuComponentsProps) {
    const dispatch = useDispatch();
    const userLevel = useSelector((app: AppState) => app.user.userLevelView);
    const [entries, setEntries] = useState([]);
    let language = getContainer().getSettingsService().getActiveLocale().code;
    const history = useHistory();

    const navigateToUserLevel = () => {
        history.push("/account/vip-level");
    };

    const loadContent = async () => {
        fetchUserLevelsPage(language).then((i) => {
            setEntries(i as any);
        });
    };

    useEffect(() => {
        dispatch(fetchUserLevelView() as any);
        if (!entries.length && language) {
            loadContent();
        }
    }, []);

    const currentLevel: number | undefined = userLevel && userLevel.currentLevel;
    const nextLevel = userLevel && userLevel.nextLevelName;
    const nextLevelPercentage: number | undefined = userLevel && userLevel.nextLevelProgressionPercentage;
    const data: any = entries && entries.length > 0 && entries[0];
    const icons = data && data.icons;

    return (
        <div className={`menu-component menu-component-fixed user-level`}>
            <div className="user-level-container">
                <div className="current-level">
                    <div className="level-icon">
                        {icons &&
                            icons.map((icon: any, idx: number) => {
                                if (!icon.file && icon.fields) {
                                    icon = icon.fields; // strapi/contentful difference
                                }
                                if (idx === currentLevel) {
                                    return <img className="icon" key={idx} src={icon && icon.file && icon.file.url} />;
                                }
                            })}
                    </div>
                    <span className="title curent-level-title"> {t(`userLevel.name.${userLevel && userLevel.currentLevelName}`)}</span>
                </div>
                <ProgressBar now={nextLevelPercentage} label={`${nextLevelPercentage}%`} style={{ borderRadius: "5px" }} />
                <div className="level-next-icon">
                    <span className="title">Next Level: {nextLevel && t(`userLevel.name.${nextLevel}`)}</span>

                    {icons &&
                        icons.map((icon: any, idx: number) => {
                            if (currentLevel != undefined) {
                                if (!icon.file && icon.fields) {
                                    icon = icon.fields;
                                }
                                if (idx === currentLevel + 1) {
                                    return <img className="icon" key={idx} src={icon && icon.file && icon.file.url} alt={icon && icon.title ? icon.title : "level-icon"} />;
                                }
                            }
                        })}
                </div>
            </div>
            <button onClick={() => navigateToUserLevel()} className="btn btn-cta user-level-btn">
                User Level
            </button>
        </div>
    );
}